import Skeleton from "@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton";
import { observer } from "mobx-react-lite";
import { IUserDiagnostic } from "types/models/UserDiagnosticsModel";
import { UserDignosticsCreateTicketSection, UserDignosticsDevopsIntegrationTab } from "../tabs/UserDignosticsDevopsIntegrationTab";
import { AppDialog, AppSectionErrorBoundary, AppSpacer } from "components/ui";
import { AppButton } from "components/form";
import { useCallback } from "react";
import { t } from "i18next";
import UserDiagnosticsAppDialogHeader from "../UserDiagnosticsAppDialogHeader";
import { useTranslation } from "react-i18next";

interface ISimpleCreateTicketDialogProps {
    isOpened: boolean;
    onClose: () => void;
    isLoading: boolean;
    isCreatingTicket: boolean;
    userDiagnostic: IUserDiagnostic | null
}

export const SimpleCreateTicketDialog = observer(({ isOpened, onClose, isLoading, isCreatingTicket, userDiagnostic }: ISimpleCreateTicketDialogProps) => {
    const { t } = useTranslation();

    const renderContent = () => {
        if (isLoading) {
            return <div className='container'>
                <Skeleton variant='rectangular' height={200} />
            </div>
        }
        else if (userDiagnostic) {
            //<UserDignosticsDevopsIntegrationTab userDiagnostic={userDiagnostic} isHandlingTicket={isCreatingTicket} />
            return <UserDignosticsCreateTicketSection userDiagnostic={userDiagnostic} isHandlingTicket={isCreatingTicket} />
        }

        return <p>{t('occurred')}</p>
    };

    const onCancelHandler = useCallback(() => {
        onClose();
    }, [onClose]);

    return (
        <AppDialog
            title={`${userDiagnostic?.userSubject || ''}`}
            isOpened={isOpened}
            onClose={onClose}
            maxWidth={'lg'}
            customHeader={<UserDiagnosticsAppDialogHeader title={`${userDiagnostic?.userSubject || ''}`} stickyHeader={true} userDiagnostic={userDiagnostic} />}
        >

            <div className='flex-auto d-flex flex-column justify-content-between'>
                <AppSectionErrorBoundary>
                    <div>
                        <section className='container'>
                            {renderContent()}
                        </section>
                        <AppSpacer space='20px' />
                    </div>
                    <footer className='d-flex align-items-center justify-content-between p-3 bg-white position-sticky border-top bottom-0 left-0 w-100 z-index-9'>
                        <AppButton variant='secondary' onClick={onCancelHandler} data-test='user-dialog-cancel-button'>
                            {t('cancel').toString()}
                        </AppButton>
                    </footer>
                </AppSectionErrorBoundary>
            </div>
        </AppDialog>
    );
})